export const INITIAL_STATE_PLAYER_VOD = {
	isReady: false,
	buffering: false,
	volume: 100,
	subtitles: [],
	isPaused: false,
	isMuted: false,
	isSidebarVisible: true,
	isFullScreen: false,
	isEnded: false,
	seekSec: 15,
	duration: 0,
	seekdTime: 0,
	movieEndMargin: 30,
	endMarginAction: false,
	endMarginActionCanceled: false,
	isPreviewAvailable: false
};

export const INITIAL_STATE_PLAYER_TV = {
	isReady: false,
	buffering: true,
	volume: 100,
	isMuted: false,
	isSidebarVisible: true,
	isEnded: false,
	isPaused: false,
	currentTime: 0,
	isFullScreen: false,
	isOnline: true,
	playlist: null,
	subtitles: [],
	isLive: false
};

export const TIME_THROTTLE = 600;

export const calculateVideoIntervalTime = (videoSession) => {
	const { till, now } = videoSession;
	const intervalTime = ((till - now) / 2) * 1000;
	return intervalTime;
};
